postMessageSig = "HELLOSIGN_MODAL"

openFormModal = ->
  client = new HelloSign({
    client_id: $("meta[id=fedora-data]").attr("data-hellosign-id")
  })

  client.on(HelloSign.events.SIGN, ->
    msg = {
      from: postMessageSig,
      message: 'complete',
      payload: {
        signature_id: eventData.signature_id
      }
    }
    parent.postMessage(msg, "*")
  )

  client.open($(".hellosign-url").attr("value"), {
    allowCancel: true,
    skipDomainVerification: $("meta[id=fedora-keys]").attr("data-env") != "production",
  })


if window.location.pathname == "/admin/complete_tax_form"
  $(document).ready(openFormModal)

msg = {
  from: postMessageSig,
  message: 'loaded'
}

parent.postMessage(msg, "*")
